export const SET_COVER_LOADING = 'SET_COVER_LOADING'
export const SET_COVER = 'SET_COVER'
export const SET_TEAM_COVER = 'SET_TEAM_COVER'
export const ADD_COVER = 'ADD_COVER'
export const EDIT_COVER = 'EDIT_COVER'
export const DELETE_COVER = 'DELETE_COVER'